import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FleetEventEffects } from './fleet-event.effects';
import { FEATURE_KEY, reducer } from './fleet-event.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(FEATURE_KEY, reducer), EffectsModule.forFeature([FleetEventEffects])],
})
export class FleetEventDataAccessModule {}
